import React, { useContext } from "react";
import { Box, Grid, makeStyles, Paper } from "@material-ui/core";

import ScalingContext from "../../../../../context/scaling/ScalingContext";
import AuthContext from "../../../../../context/auth/AuthContext";

import UserCampaignFilter from "./User";
import AdminCampaignFilter from "./Admin";

export default function CampaignFilter() {
  const useStyles = makeStyles(() => ({
    paper: {
      padding: 8,
    },
    fieldWrapper: {
      paddingRight: 15,
    },
    iconButton: {
      padding: 10,
    },
  }));
  const classes = useStyles();

  const { setSortValue, setSearchValue, search_value } =
    useContext(ScalingContext);
  const { user } = useContext(AuthContext);

  const sort = (e) => {
    // Function: Set Sort Value
    setSortValue(e.target.value);
  };

  const search = (e) => {
    // Function: Set Search Value
    const id = e.target.id;
    const value = e.target.value;

    let data = { ...search_value };

    if (id === "media_buyer") {
      data[id] = value === "All" ? "" : value;
    }

    if (["scaling_status", "action_status"].includes(id)) {
      const checked = e.target.checked;
      const name = e.target.name;

      if (checked && !data[id].includes(name)) {
        data[id].push(name);
      }

      if (!checked && data[id].includes(name)) {
        data[id] = data[id].filter((status) => status !== name);
      }
    }

    if (id === "text") {
      data[id] = value;
    }

    setSearchValue(data);
  };

  const clearSearch = () => {
    // Function: Clear Search Text
    if (search_value.text) {
      setSearchValue({ ...search_value, text: "" });
    }
  };

  return (
    <Grid item xs={12}>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={(e) => e.preventDefault()}
      >
        <Paper elevation={4} className={classes.paper}>
          <Grid container alignItems="center" justifyContent="space-between">
            {" "}
            {/* Admin Filter Access */}{" "}
            {user.user_group === "admin" && (
              <AdminCampaignFilter classes={classes} search={search} />
            )}
            {/* General Filter */}{" "}
            <UserCampaignFilter
              classes={classes}
              sort={sort}
              search={search}
              clearSearch={clearSearch}
            />{" "}
          </Grid>{" "}
        </Paper>{" "}
      </Box>{" "}
    </Grid>
  );
}
